export var IdCountryCode;
(function (IdCountryCode) {
    IdCountryCode["Argentina"] = "ar";
    IdCountryCode["Australia"] = "au";
    IdCountryCode["Bulgary"] = "bg";
    IdCountryCode["Brasil"] = "br";
    IdCountryCode["CzechRepublic"] = "cz";
    IdCountryCode["Germany"] = "de";
    IdCountryCode["Danmark"] = "dk";
    IdCountryCode["Spain"] = "es";
    IdCountryCode["Finland"] = "fi";
    IdCountryCode["France"] = "fr";
    IdCountryCode["UnitedKingdom"] = "gb";
    IdCountryCode["Greece"] = "gr";
    IdCountryCode["Hungary"] = "hu";
    IdCountryCode["Italy"] = "it";
    IdCountryCode["Japan"] = "jp";
    IdCountryCode["Lithuania"] = "lt";
    IdCountryCode["Mexico"] = "mx";
    IdCountryCode["Netherlands"] = "nl";
    IdCountryCode["Norway"] = "no";
    IdCountryCode["Poland"] = "pl";
    IdCountryCode["International"] = "us";
    IdCountryCode["Portugal"] = "pt";
    IdCountryCode["Romania"] = "ro";
    IdCountryCode["Russia"] = "ru";
    IdCountryCode["Sweden"] = "se";
    IdCountryCode["Slovenia"] = "sk";
    IdCountryCode["Turkey"] = "tr";
    IdCountryCode["UnitedStates"] = "us";
})(IdCountryCode || (IdCountryCode = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/IdCountryCode.ts
// module id = 660
// module chunks = 3